import { SubDrawer } from '@esg/ui';
import React from 'react';
import { useAtom } from 'jotai';

import { DrawerCustom } from './DrawerCustom';
import { globalDrawerState } from '@esg/framework';

export const DrawerGlobal = () => {
    const [drawerState, setDrawerState] = useAtom(globalDrawerState);
    const resetDrawerState = () => setDrawerState(globalDrawerState.init);

    return (
        <DrawerCustom
            onClose={() => {
                drawerState?.onClose?.();
                resetDrawerState();
            }}
            open={drawerState?.isOpen}
            drawerTitle={drawerState?.titleTransCode}
            drawerSubtitle={drawerState?.subtitle}
            footer={drawerState?.footer}
            hideHeader={drawerState?.hideHeader}
            drawerTitleAction={drawerState?.titleAction}
        >
            {drawerState?.content}
            <SubDrawer />
        </DrawerCustom>
    );
};
